import React from "react";
import { colors } from "../../utils";

const ColorLibrary = ({ color = colors.PrimaryPurple, width = 16, height = 21 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.375H2C0.9 0.375 0 1.275 0 2.375V18.375C0 19.475 0.9 20.375 2 20.375H14C15.1 20.375 16 19.475 16 18.375V2.375C16 1.275 15.1 0.375 14 0.375ZM5 2.375H7V7.375L6 6.625L5 7.375V2.375ZM14 18.375H2V2.375H3V11.375L6 9.125L9 11.375V2.375H14V18.375Z"
      fill={color}
    />
  </svg>
);

export default ColorLibrary;
